import PanelNew from '@/containers/SubscriptionFormPageNew/Panel/PanelNew'
import logo from '../../Components/Address/home.svg'
import Address from '../../Components/Address/Address'
import AddressSelectorField from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/AddressSelector/AddressSelectorField'
import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'
import AddAddressButton from '@/containers/SubscriptionFormPageNew/Components/Address/Fields/Default/AddAddressButton'

const Addresses = () => {
  const { t, addressesList, activeAddress } = useAddress()

  return (
    <div style={{ width: '100%' }}>
      <div>
        <PanelNew
          alt={t(['subscriptionForm:address_module.module_title_v2', 'subscriptionForm:address_module.module_title'])}
          logo={logo}
          title={t(['subscriptionForm:address_module.module_title_v2', 'subscriptionForm:address_module.module_title'])}
          id='AddressModule'
        >
          <AddressSelectorField module='client' />
          <AddAddressButton />
          <Address
            hidden={!activeAddress && addressesList.length}
            title={
              activeAddress === 'new' || !activeAddress
                ? t('subscriptionForm:address_module.create_address_title')
                : t('subscriptionForm:address_module.edit_address_title') + addressesList[activeAddress]
            }
          />
        </PanelNew>
      </div>
    </div>
  )
}

export default Addresses
